import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Experiences from "./pages/Experiences";
import ExperienceDetail from "./pages/ExperienceDetail";
import Membership from "./pages/Membership";
import MediaDay from "./pages/MediaDay";
import Store from "./pages/Store";
import Programs from "./pages/Programs";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import StepUpBooking from "./pages/StepUpBooking";
import MediaMerchandise from "./pages/MediaMerchandise";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PaymentResult from "./pages/PaymentResult";

import Dashboard from "./pages/parent/Dashboard";
import Students from "./pages/parent/Students";
import Forms from "./pages/parent/Forms";
import Payments from "./pages/parent/Payments";
import ExplorerPass from "./pages/parent/ExplorerPass";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminExperiences from "./pages/admin/AdminExperiences";
import AdminExperienceManage from "./pages/admin/AdminExperienceManage";
import AdminCheckIn from "./pages/admin/AdminCheckIn";
import AdminFinances from "./pages/admin/AdminFinances";
import AdminAnnouncements from "./pages/admin/AdminAnnouncements";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminContent from "./pages/admin/AdminContent";
import AdminScholarship from "./pages/admin/AdminScholarship";
import AdminForms from "./pages/admin/AdminForms";

const ADMIN = ["admin", "super_admin"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/experiences/:id" element={<ExperienceDetail />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/memberships" element={<Membership />} />
          <Route path="/media-day" element={<MediaDay />} />
          <Route path="/store" element={<Store />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/step-up-booking" element={<StepUpBooking />} />
          <Route path="/media-merchandise" element={<MediaMerchandise />} />
          <Route path="/events" element={<Experiences />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/students" element={<ProtectedRoute><Students /></ProtectedRoute>} />
          <Route path="/forms" element={<ProtectedRoute><Forms /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
          <Route path="/explorer-pass/:studentId" element={<ProtectedRoute><ExplorerPass /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={ADMIN}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/experiences" element={<ProtectedRoute roles={ADMIN}><AdminExperiences /></ProtectedRoute>} />
          <Route path="/admin/experiences/:id" element={<ProtectedRoute roles={ADMIN}><AdminExperienceManage /></ProtectedRoute>} />
          <Route path="/admin/checkin" element={<ProtectedRoute roles={ADMIN}><AdminCheckIn /></ProtectedRoute>} />
          <Route path="/admin/finances" element={<ProtectedRoute roles={ADMIN}><AdminFinances /></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute roles={ADMIN}><AdminInquiries /></ProtectedRoute>} />
          <Route path="/admin/scholarship" element={<ProtectedRoute roles={ADMIN}><AdminScholarship /></ProtectedRoute>} />
          <Route path="/admin/forms" element={<ProtectedRoute roles={ADMIN}><AdminForms /></ProtectedRoute>} />
          <Route path="/admin/content" element={<ProtectedRoute roles={ADMIN}><AdminContent /></ProtectedRoute>} />
          <Route path="/admin/announcements" element={<ProtectedRoute roles={ADMIN}><AdminAnnouncements /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
